import { observer } from 'mobx-react';
import React, { ChangeEvent, useCallback } from 'react';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import { ICaloriesValidation } from 'src/types/main';
import { isDisabledByPos } from 'src/utils/helpers';
import { ICustomTooltipProps } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import InputAlt from 'src/view/components/Controls/InputAlt/InputAlt';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';

interface IProps {
  calories: number | null;
  validation?: ICaloriesValidation;
  posRestriction?: RESTRICTION_ACCESS;
  disabled?: boolean;
  changeCalories: (calories: number | null) => void;
  setValidation?: () => void;
  className?: string;
  wrapperClassName?: string;
  tooltipOptions?: Partial<ICustomTooltipProps>;
}

const MenuManagTabItemCaloriesInput: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const changeCalories = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value.trim();
      const number = Number(value);
      if (isNaN(number) || !/^[0-9]{0,6}$/.test(value)) return;
      // if no value is set we should send null to backend as default value
      props.changeCalories(value.length ? number : null);
      // update validation
      if (props.validation && !props.validation?.state && props.setValidation) props.setValidation();
    },
    [props.validation, props.setValidation]
  );

  return (
    <IntegrationManager
      setting={props.posRestriction}
      wrapperClassName={props.wrapperClassName}
      withTooltip
      tooltipOptions={{ wrapperClassName: 'w-fit-content' }}
    >
      <InputAlt
        type="text"
        // space required !!!
        value={props.calories?.toString() || ' '}
        onInput={changeCalories}
        validation={props.validation ? { ...props.validation, styleType: 'bottom' } : undefined}
        disabled={props.disabled && !isDisabledByPos(props.posRestriction)}
        className={`py-0 ${props.className || ''}`}
      />
    </IntegrationManager>
  );
});

MenuManagTabItemCaloriesInput.defaultProps = {
  posRestriction: RESTRICTION_ACCESS.ALLOWED,
};

export default MenuManagTabItemCaloriesInput;
